module.exports = __webpack_public_path__ + "img/safeortho_logo_white.94c82307.png";